import { render } from "./DownloadPdf.vue?vue&type=template&id=67d455fb&scoped=true"
import script from "./DownloadPdf.vue?vue&type=script&lang=js"
export * from "./DownloadPdf.vue?vue&type=script&lang=js"

import "./DownloadPdf.vue?vue&type=style&index=0&id=67d455fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d455fb"]])

export default __exports__